import React from "react";
import { Button, Container, Form, Header, Icon } from "semantic-ui-react";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import logo from "../../images/logo/logo-full-black.png";
import { dispatch } from "@rematch/core";
import LoadingComponent from "./LoadingComponent";

class CreateWorkspace extends React.Component {
  state = {
    step: 1,
    workspaceName: "",
    teamName: "",
    users: [{ email: "", firstName: "", lastName: "" },{email:"",firstName:"",lastName:""}],
    addWorkspaceError: null,
    errors: {},
    loading: false,
    loadingMessage: "",
    visibleRows:2,
    firstNameRequiredFlags: {}
  };

  validateEmail = (email, index, users, accountEmail) => {
    const emailRegex = /^[a-zA-Z0-9]+([._-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9]+([.-]?[a-zA-Z0-9]+)*(\.[a-zA-Z]{2,})+$/;
  
    if (!emailRegex.test(email)) {
      return "Invalid email address.";
    }
    if (email.toLowerCase() === accountEmail.toLowerCase()) {
      return "This user already exists in this team.";
    }
    const duplicateCount = users.filter(
      (user, idx) => idx !== index && user.email.toLowerCase() === email.toLowerCase()
    ).length;
    if (duplicateCount > 0) {
      return "Duplicate email address.";
    }
    return null;
  };

  handleNext = async () => {
    const { step, workspaceName, teamName, users } = this.state;
    const errors = {};
    let filteredUsers;
    // Validation for Step 1
    if (step === 1) {
      if (!workspaceName) {
        errors.workspaceName = "Workspace Name is required.";
      }
    }

    // Validation for Step 2
    if (step === 2) {
      if (!teamName) {
        errors.teamName = "Team Name is required.";
      }
      filteredUsers = users.filter((user) => {
        const { email, firstName, lastName } = user;
        return email || firstName || lastName;
      });
      filteredUsers.forEach((user, index) => {
        const { email, firstName, lastName } = user;
        if (email || firstName || lastName) {
          if (!email) {
            errors[`email-${index}`] = "Email is required.";
          } else {
            const emailError = this.validateEmail(
              email,
              index,
              users,
              this.props.selectedAccount.email
            );
            if (emailError) {
              errors[`email-${index}`] = emailError;
            }
          }
          if (!firstName) errors[`firstName-${index}`] = "First Name is required.";
          if (!lastName) errors[`lastName-${index}`] = "Last Name is required.";
        }
      });
    }

    this.setState({ errors });

    // If no errors, proceed
    if (Object.keys(errors).length === 0) {
      if (step === 1) {
        this.setState({
          loading: true,
          loadingMessage: "Creating Your Workspace",
        });
        const payload = {
          workspaceName,
          accountId: this.props.match.params.accountId,
        };
        await dispatch.app.addNewWorkspaceFreemiumUser(payload);
        this.setState({ loading: false, loadingMessage: "" });
      } else if (step === 2) {
        this.setState({
          loading: true,
          loadingMessage: "Creating Your Team And Inviting Users",
        });
        try {
          const payload = {
            name: teamName,
            accountId: this.props.match.params.accountId,
          };
          await dispatch.organizationUnit.createTeam(payload);
          for (let user of filteredUsers) {
            const inviteUsersPayload = {
              firstName: user.firstName,
              lastName: user.lastName,
              email: user.email.toLowerCase(),
              role: "Member",
            };
            inviteUsersPayload.accountId = this.props.match.params.accountId;
            inviteUsersPayload.String = "ChckBeforeCreateInvite";
            inviteUsersPayload.StrType = "createInviteForOrgToSubOrgInvitation";
            inviteUsersPayload.referenceCollection = "suborganizations";
            await dispatch.invite.inviteNewUser(inviteUsersPayload);
          }
          await dispatch.account.getAllAccounts();
          this.props.history.push(
            `/app/${
              this.props.match.params.accountId
            }/_ws/${this.props.selectedOrganisation.id.toString()}/_pb`
          );
          window.location.reload();
        } catch (err) {
          this.setState({ loading: false, loadingMessage: "" });
          return;
        }
      }

      this.setState((prevState) => ({
        step: prevState.step + 1,
        errors: {},
      }));
    }
  };

  handleBack = () => {
    this.setState((prevState) => ({
      step: Math.max(prevState.step - 1, 1),
      errors: {},
    }));
  };

  removeUserFields = (index) => {
    this.setState((prevState) => {
    const newErrors = { ...prevState.errors };
    delete newErrors[`email-${index}`];
    delete newErrors[`firstName-${index}`];
    delete newErrors[`lastName-${index}`];
    const reindexedErrors = {};
    const users = prevState.users.filter((_, i) => i !== index);
    Object.keys(newErrors).forEach(key => {
      const [field, oldIndex] = key.split('-');
      if (oldIndex > index) {
        reindexedErrors[`${field}-${oldIndex - 1}`] = newErrors[key];
      } else {
        reindexedErrors[key] = newErrors[key];
      }
    });

    return {
      users: users,
      errors: reindexedErrors
    };
  });
  };

  handleInputChange = (field, value) => {
    this.setState({
      [field]: value,
      errors: { ...this.state.errors, [field]: "" },
    });
  };

  handleUserInputChange = (index, field, value) => {
    this.setState((prevState) => {
      const newUsers = [...prevState.users];
      newUsers[index] = { ...newUsers[index], [field]: value };
      const hasAnyValue = ['firstName', 'lastName', 'email'].some(fieldName => 
        newUsers[index][fieldName].trim() !== ''
      );
      newUsers[index].isFirstNameRequired = hasAnyValue;
      newUsers[index].isLastNameRequired = hasAnyValue;
      newUsers[index].isEmailRequired = hasAnyValue;

      const newErrors = { ...prevState.errors };
      delete newErrors[`${field}-${index}`];

      // Check if all fields are filled before adding a new row
      const isRowFilled = ['firstName', 'lastName', 'email'].every(
        fieldName => newUsers[index][fieldName].trim() !== ''
    );

    // Add new row only if the last visible row is fully completed
    if (index === newUsers.length - 2 && isRowFilled) {
        newUsers.push({ firstName: "", lastName: "", email: "" });
    }

      return {
        users: newUsers,
        errors: newErrors,
      };
    });
   };

  handleEmailBlur = (index) => {
    const email = this.state.users[index].email;
    if (email.trim() !== '') {
      const emailError = this.validateEmail(
        email,
        index,
        this.state.users,
        this.props.selectedAccount.email
      );
      
      if (emailError) {
        this.setState(prevState => ({
          errors: {
            ...prevState.errors,
            [`email-${index}`]: emailError
          }
        }));
      }
    }
  };

  onSkip = () => {
    this.props.history.push(
      `/app/${
        this.props.match.params.accountId
      }/_ws/${this.props.selectedOrganisation.id.toString()}/_pb`
    );
    dispatch.lifeCycle.setFilterByStatus(["-1","0","1","2","3","4","5","10"]);
  };
  addUserFields = () => {
    this.setState((prevState) => ({
      users: [...prevState.users, { email: "", firstName: "", lastName: "" }],
    }));
  };
 
  handleDeleteRow = (indexToDelete) => {
    this.setState(prevState => {
      const newUsers = prevState.users.filter((_, index) => index !== indexToDelete);
      newUsers.push({ email: "", firstName: "", lastName: "" });
        const newFirstNameRequiredFlags = {};
      Object.keys(prevState.firstNameRequiredFlags).forEach(oldIndex => {
        if (oldIndex < indexToDelete) {
          newFirstNameRequiredFlags[oldIndex] = prevState.firstNameRequiredFlags[oldIndex];
        } else if (oldIndex > indexToDelete) {
          newFirstNameRequiredFlags[oldIndex - 1] = prevState.firstNameRequiredFlags[oldIndex];
        }
      });
      return {
        users: newUsers,
        visibleRows: prevState.visibleRows, 
        firstNameRequiredFlags: newFirstNameRequiredFlags,
        errors: {}
      };
    });
  };

  render() {
    const { step, workspaceName, teamName, users, errors, visibleRows, firstNameRequiredFlags } = this.state;
    const totalSteps = 2;
    const progressPercentage = (step / totalSteps) * 100;

    return (
      <div className="backgroundCss">
        <LoadingComponent
          active={this.state.loading}
          message={this.state.loadingMessage}
        />
        <Container className="pad_40 bg-white">
          <Header style={{ margin: "10px" }} textAlign="center">
            <img
              src={`${logo}`}
              alt="Logo"
              style={{ width: "150px", height: "auto" }}
            />
          </Header>
          <div
            style={{ marginTop: "30px", fontSize: "24px", textAlign: "center" }}
          >
            <b>Congratulations! Your account has been created</b>
          </div>
          {/* <div
            className="text-muted"
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "10px",
              fontSize: "10px",
            }}
          >
            <div style={{ width: "350px", textAlign: "center" }}>
              <b className="text-bold-large">
                Take a few minutes to tell us about your team or project.
              </b>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
              fontSize: "10px",
            }}
          >
            <div
              style={{
                height: "6px",
                backgroundColor: "#f3f3f3",
                borderRadius: "5px",
                width: "400px",
              }}
            >
              <div
                style={{
                  width: `${progressPercentage}%`,
                  height: "100%",
                  backgroundColor: "#3b82f6",
                  borderRadius: "5px",
                  transition: "width 0.3s ease",
                }}
              />
            </div>
          </div> */}
          {step === 1 && (
            <div>
            <div
            className="text-muted"
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "10px",
              fontSize: "10px",
            }}
          >
            <div style={{ width: "350px", textAlign: "center" }}>
              <b className="text-bold-large">
                  Create your workspace.
              </b>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "60px",
              fontSize: "10px",
            }}
          >
            <div
              style={{
                height: "6px",
                backgroundColor: "#f3f3f3",
                borderRadius: "5px",
                width: "400px",
              }}
            >
              <div
                style={{
                  width: `${progressPercentage}%`,
                  height: "100%",
                  backgroundColor: "#3b82f6",
                  borderRadius: "5px",
                  transition: "width 0.3s ease",
                }}
              />
            </div>
          </div>
              <div
                style={{
                  marginTop: "30px",
                  fontSize: "24px",
                  textAlign: "center",
                }}
              >
                <b>Name Your Workspace</b>
              </div>
              <div
                className="text-muted"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "10px",
                  fontSize: "10px",
                }}
              >
                <div style={{ width: "380px", textAlign: "center" }}>
                  <b className="text-bold-large">
                    Your workspace is where you will manage your content and
                    collaborators.
                  </b>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "20px",
                }}
              >
                <Form
                  id="createWorkspace"
                  style={{ width: "400px" }}
                >
                  <Form.Input
                    name="workspaceName"
                    placeholder="Enter Workspace Name"
                    required
                    label="Workspace Name"
                    value={workspaceName || ""}
                    onChange={(e) =>
                      this.handleInputChange("workspaceName", e.target.value)
                    }
                    autoFocus
                  />
                  {errors.workspaceName && (
                    <div className="error">{errors.workspaceName}</div>
                  )}
                  <div style={{textAlign: "center"}}><b>You can change your workspace name later.</b></div>
                  <div style={{ display: "flex", justifyContent: "center", gap: "20px", marginTop: "30px" }}>
                  {step > 1 && (
                    <Button className="button-cancel float-right mar_0" onClick={this.handleBack}>Back</Button>
                  )}
                    <Button className="button-submit float-right mar_0" type="button" onClick={this.handleNext} disabled={this.state.loading}>
                      {step === 3 ? "Submit" : "Next"}</Button>
                </div>
                </Form>
              </div>
            </div>
          )}
          {step === 2 && (
            <div>
              <div
            className="text-muted"
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "10px",
              fontSize: "10px",
            }}
          >
            <div style={{ width: "400px", textAlign: "center",marginTop:"2px" }}>
              <b className="text-bold-large">
                  Create your first team and invite others to join the team.
              </b>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "40px",
              fontSize: "10px",
            }}
          >
            <div
              style={{
                height: "6px",
                backgroundColor: "#f3f3f3",
                borderRadius: "5px",
                width: "400px",
              }}
            >
              <div
                style={{
                  width: `${progressPercentage}%`,
                  height: "100%",
                  backgroundColor: "#3b82f6",
                  borderRadius: "5px",
                  transition: "width 0.3s ease",
                }}
              />
            </div>
          </div>
            
              <div
                style={{
                  marginTop: "25px",
                  fontSize: "24px",
                  textAlign: "center",
                }}
              >
                <b>Create a Team</b>
              </div>
              <Form
                id="createTeam"
                onSubmit={(e) => {
                  e.preventDefault();
                  this.handleNext();
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "10px",
                  }}
                >
                  <div>
                    <Form.Input
                      name="teamName"
                      placeholder="Team Name"
                      required
                      label="Team Name"
                      value={teamName || ""}
                      onChange={(e) =>
                        this.handleInputChange("teamName", e.target.value)
                      }
                      style={{ width: "400px" }}
                    />
                    {errors.teamName && (
                      <div
                        className="error"
                        style={{ color: "red", fontSize: "12px" }}
                      >
                        {errors.teamName}
                      </div>
                    )}
                  </div>
                </div><br></br>
                <div style={{textAlign: "center"}}><p>You can change your team name later.</p></div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "20px",
                    fontSize: "10px",
                  }}
                >
                  <div
                    style={{
                      height: "2px",
                      backgroundColor: "#f3f3f3",
                      borderRadius: "5px",
                      width: "600px",
                    }}
                  >
                    <div
                      style={{
                        width: `100%`,
                        height: "100%",
                        backgroundColor: "#CCCCCC",
                        borderRadius: "5px",
                        transition: "width 0.3s ease",
                      }}
                    />
                  </div>
                </div>
                <div
                  style={{
                    marginTop: "25px",
                    fontSize: "24px",
                    textAlign: "center",
                  }}
                >
                  <b>Invite users to team</b>
                </div><br></br>
                <div style={{textAlign: "center"}}><p>This step is optional. You have already been added to your team.</p></div><br></br>
                <div style={{ 
                  maxHeight: "400px",
                  overflowY: "auto",
                  margin: "0 50px"
                }}>
                  {users.map((user, index) => (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "10px",
                        padding: "10px 0",
                      }}
                    >
                      <div style={{ display: "flex", width: "90%", gap: "30px" }}>
                        <div style={{ flex: "1 1 auto", minWidth: "150px" }}>
                          <label>First Name {(user.isFirstNameRequired) && <span style={{ color: "red" }}>*</span>}</label>
                          <input
                            name={`firstName-${index}`}
                            placeholder="Enter First Name"
                            value={user.firstName || ""}
                            onChange={(e) => this.handleUserInputChange(index, "firstName", e.target.value)}
                            style={{ width: "100%" }}
                            tabIndex={index * 3 + 1}
                            required={user.isFirstNameRequired}
                          />
                          <div style={{ minHeight: "20px" }}>
                          {errors[`firstName-${index}`] && (
                            <div style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
                              {errors[`firstName-${index}`]}
                            </div>
                          )}
                          </div>
                        </div>
                        <div style={{ flex: "1 1 auto", minWidth: "150px" }}>
                          <label>Last Name {(user.isLastNameRequired) && <span style={{ color: "red" }}>*</span>}
                          </label>
                          <input
                            name={`lastName-${index}`}
                            placeholder="Enter Last Name"
                            value={user.lastName || ""}
                            onChange={(e) =>
                              this.handleUserInputChange(index, "lastName", e.target.value)
                            }
                            style={{ width: "100%" }}
                            tabIndex={index * 3 + 2}
                            required={user.isLastNameRequired}
                          />
                          <div style={{ minHeight: "20px" }}>
                          {errors[`lastName-${index}`] && (
                            <div style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
                              {errors[`lastName-${index}`]}
                            </div>
                          )}
                          </div>
                        </div>
                        <div style={{ flex: "1 1 auto", minWidth: "150px" }}>
                          <label>Email {(user.isEmailRequired) && <span style={{ color: "red" }}>*</span>}
                          </label>
                          <input
                            name={`email-${index}`}
                            placeholder="Enter Email"
                            value={user.email || ""}
                            onChange={(e) =>
                              this.handleUserInputChange(index, "email", e.target.value)
                            }
                            onBlur={() => this.handleEmailBlur(index)}
                            style={{ width: "100%" }}
                            tabIndex={index * 3 + 3}
                            required={user.isEmailRequired}
                          />
                          <div style={{ minHeight: "20px" }}>
                          {errors[`email-${index}`] && (
                            <div style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
                              {errors[`email-${index}`]}
                            </div>
                          )}
                          </div>
                        </div>
                      </div>
                      <div style={{ 
                        display: "flex", 
                        alignItems: "center", 
                        paddingTop: "25px",
                        cursor: "pointer" 
                      }}>
                        {(user.firstName || user.lastName || user.email) && (
                          <Icon
                            name="trash"
                            //color="black"
                            className="trash-color"
                            onClick={() => this.handleDeleteRow(index)}
                            tabIndex={index * 3 + 4}
                            style={{ fontSize: "15px", marginTop: "-3px", }}
                          />
                        )}
                      </div>
                    </div>
                  ))}
                </div>
                <div style={{textAlign: "center"}}><p>You can manage the users in your team later.</p></div>
                <div style={{ display: "flex", justifyContent: "center", gap: "20px", marginTop: "30px" }}>
                  {/* {step > 1 && (
                    <Button className="button-cancel float-right mar_0" onClick={this.handleBack}>Back</Button>
                  )} */}
                    <Button className="button-submit float-right mar_0" onClick={this.handleNext} disabled={this.state.loading}>
                      {step > 1 ? "Submit" : "Next"}</Button>
                </div>
              </Form>
            </div>
          )}
        </Container>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    selectedOrganisation: state.app.selectedOrganisation,
    user: state.app.user,
    selectedAccount: state.app.selectedAccount,
    createdTeam: state.organizationUnit.createdTeam,
  };
}

const connectedCreateWorkspacePage = connect(mapStateToProps)(CreateWorkspace);
export { connectedCreateWorkspacePage as CreateWorkspace };
